import React, { useState } from 'react';
import axios from 'axios';

// ⚙️ CONFIGURACIÓN CENTRALIZADA (Mantenemos tu puerto 4001)
const BACKEND_URL = '';

const TarjetaMuro = ({ post, config }) => {
    // 🧠 ESTADOS INTERNOS ORIGINALES (Mantenidos línea por línea)
    const [velas, setVelas] = useState(post.velas_contador || 0);
    const [showComentarios, setShowComentarios] = useState(false);
    const [comentarios, setComentarios] = useState([]);
    const [totalComentarios, setTotalComentarios] = useState(parseInt(post.total_mensajes) || 0);
    const [nuevoMensaje, setNuevoMensaje] = useState('');
    const [autorMensaje, setAutorMensaje] = useState('');
    const [enviando, setEnviando] = useState(false);
    const [comentariosCargados, setComentariosCargados] = useState(false);
    const [pensandoIA, setPensandoIA] = useState(false); 

    // 🎨 TUS ESTILOS ORIGINALES (Mantenidos línea por línea)
    const cardStyle = {
        backgroundColor: 'rgba(255, 255, 255, 0.95)', 
        borderRadius: '12px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
        marginBottom: '30px',
        overflow: 'hidden',
        border: '1px solid rgba(255, 255, 255, 0.8)'
    };

    const actionButtonStyle = {
        flex: 1, background: 'none', border: 'none', color: '#65676b', 
        fontWeight: '600', cursor: 'pointer', padding: '12px',
        fontSize: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
        transition: 'background-color 0.2s'
    };

    const chatBubbleStyle = {
        backgroundColor: '#f0f2f5', 
        borderRadius: '18px',
        padding: '8px 15px',
        display: 'inline-block',
        maxWidth: '100%', 
        overflowWrap: 'break-word', 
        wordWrap: 'break-word', 
        whiteSpace: 'pre-wrap', 
        height: 'auto'
    };

    // ⚡️ TUS ACCIONES ORIGINALES
    const handleVela = async () => {
        try {
            setVelas(prev => prev + 1);
            await axios.post(`${BACKEND_URL}/api/v1/biografia/${post.difunto_id}/vela`);
        } catch (error) { console.error("Error vela", error); }
    };

    const toggleComentarios = () => {
    if (!showComentarios && !comentariosCargados) {
        // ✅ Cambiamos la URL absoluta por la ruta local de la demo
        // Puedes apuntar a difuntos/index.json si ahí tienes los comentarios de prueba
        axios.get('/api/v1/difuntos/index.json')
            .then(res => {
                // En la demo, buscamos si el difunto actual tiene condolencias en el JSON
                const difuntoActual = Array.isArray(res.data) 
                    ? res.data.find(d => d.id === post.difunto_id) 
                    : null;
                
                setComentarios(difuntoActual?.condolencias || []);
                setComentariosCargados(true);
            })
            .catch(err => {
                console.error("Error cargando condolencias locales:", err);
                setComentarios([]); // Evitamos que se quede colgado
            });
    }
    setShowComentarios(!showComentarios);
};

    const generarConIA = async () => {
        // Quitamos la restricción de que tenga que haber texto previo para que 
        // el botón funcione incluso con el cuadro vacío (análisis manual vs IA)
        setPensandoIA(true);
        try {
            // CAMBIO CLAVE: Usamos BACKEND_URL (que es 4001) en lugar de localhost:4000
            const response = await axios.post(`${BACKEND_URL}/api/v1/public/ai/generar-pesame`, {
                ideas: nuevoMensaje || "un mensaje de apoyo", // Si está vacío, la IA propone algo
                cliente_id: config?.id,
                nombre_municipio: config?.nombre_ayuntamiento || config?.nombre
            });
            
            if (response.data && response.data.mensaje) {
                setNuevoMensaje(response.data.mensaje);
            }
        } catch (error) {
            console.error("Error al conectar con la IA:", error);
            // Si falla la red, el backend ya tiene un BACKUP, pero por si acaso:
            if (!nuevoMensaje) setNuevoMensaje("Mi más sentido pésame para toda la familia.");
        } finally {
            setPensandoIA(false);
        }
    };

    const enviarComentario = async () => {
        if (!nuevoMensaje.trim() || !autorMensaje.trim()) return alert("Escribe nombre y mensaje.");
        setEnviando(true);
        try {
            await axios.post(`${BACKEND_URL}/api/v1/condolencias`, {
                difunto_id: post.difunto_id,
                nombre_remitente: autorMensaje,
                mensaje: nuevoMensaje
            });
            const nuevo = { id: Date.now(), nombre_remitente: autorMensaje, mensaje: nuevoMensaje };
            setComentarios([nuevo, ...comentarios]);
            setTotalComentarios(prev => prev + 1);
            setNuevoMensaje('');
        } catch (error) {
            alert("Error al enviar.");
        } finally {
            setEnviando(false);
        }
    };

    // 🖼️ TU RENDERIZADO ORIGINAL
    return (
        <div style={cardStyle}>
            <div style={{ padding: '15px 20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: '45px', height: '45px', borderRadius: '50%', backgroundColor: '#eee', overflow: 'hidden', border:'2px solid white', boxShadow:'0 2px 5px rgba(0,0,0,0.1)' }}>
                    {post.foto_url ? (
                        <img 
                            src={post.foto_url.startsWith('http') ? post.foto_url : `${BACKEND_URL}${post.foto_url}`} 
                            alt="Avatar" 
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                        />
                    ) : <div style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}>👤</div>}
                </div>
                <div>
                    <h4 style={{ margin: 0, fontSize: '17px', color: '#050505' }}>{post.nombre} {post.apellidos}</h4>
                    <span style={{ fontSize: '13px', color: '#65676b' }}>
                        {post.fecha_defuncion ? `Fallecido el ${post.fecha_defuncion.split('T')[0]}` : 'Fecha reciente'}
                    </span>
                </div>
            </div>

            <div style={{ padding: '0 20px 10px 20px', fontSize: '15px', color: '#050505', lineHeight:'1.6', whiteSpace: 'pre-wrap' }}>
                {post.texto_html}
            </div>

            {post.foto_url && (
                <div style={{ width: '80%', maxWidth:'500px', margin: '10px auto 20px auto', borderRadius: '8px', overflow: 'hidden', boxShadow:'0 4px 12px rgba(0,0,0,0.1)' }}>
                    <img 
                        src={post.foto_url.startsWith('http') ? post.foto_url : `${BACKEND_URL}${post.foto_url}`}
                        alt="Post" 
                        style={{ width: '100%', display: 'block', maxHeight: '500px', objectFit: 'contain', backgroundColor: '#f9f9f9' }} 
                    />
                </div>
            )}

            <div style={{ padding: '0 20px 10px 20px', display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#65676b' }}>
                <span>🕯️ {velas} velas encendidas</span>
                {!showComentarios && (
                    <span 
                        style={{cursor: 'pointer', fontWeight:'500'}} 
                        onClick={toggleComentarios}
                    >
                        {totalComentarios > 0 ? `💬 Ver ${totalComentarios} comentarios` : 'Sé el primero en comentar'}
                    </span>
                )}
            </div>

            <div style={{ display: 'flex', borderTop: '1px solid #ced0d4', padding: '4px 10px' }}>
                <button style={actionButtonStyle} onClick={handleVela}>🕯️ Encender Vela</button>
                <button style={actionButtonStyle} onClick={toggleComentarios}>🙏 Dar el Pésame</button>
            </div>

            {showComentarios && (
                <div style={{ padding: '15px', backgroundColor: '#fff', borderTop: '1px solid #ced0d4', position: 'relative' }}>
                    <button onClick={() => setShowComentarios(false)} style={{ position: 'absolute', right: '15px', top: '10px', background: 'none', border: 'none', fontSize: '20px', color: '#65676b', cursor: 'pointer' }}>×</button>
                    <h5 style={{margin:'0 0 15px 0', color:'#65676b'}}>✍️ Libro de Condolencias:</h5>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
                        {comentarios.length === 0 && <p style={{textAlign:'center', color:'#65676b', fontSize:'13px'}}>No hay mensajes todavía.</p>}
                        {comentarios.map(c => (
                            <div key={c.id} style={{ display: 'flex', gap: '8px' }}>
                                <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: '#ddd', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'12px', flexShrink:0 }}>👤</div>
                                <div style={chatBubbleStyle}>
                                    <span style={{ display: 'block', fontWeight: 'bold', fontSize: '13px', color: '#050505', marginBottom:'2px' }}>{c.nombre_remitente}</span>
                                    <span style={{ fontSize: '14px', color: '#050505' }}>{c.mensaje}</span>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                        <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: config?.color_principal || '#2E7D32', display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontSize:'12px', flexShrink:0 }}>Yo</div>
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <input type="text" placeholder="Tu Nombre" value={autorMensaje} onChange={e => setAutorMensaje(e.target.value)} style={{ width: '100%', padding: '8px 12px', borderRadius: '18px', border: '1px solid #ddd', backgroundColor: '#f0f2f5', outline: 'none', fontSize: '14px' }} />
                            <div style={{ position: 'relative' }}>
                                <input 
                                    type="text" 
                                    placeholder={pensandoIA ? "✨ La IA está escribiendo..." : "Escribe algo..."} 
                                    value={nuevoMensaje} 
                                    onChange={e => setNuevoMensaje(e.target.value)} 
                                    disabled={pensandoIA}
                                    style={{ width: '100%', padding: '10px 40px 10px 12px', borderRadius: '18px', border: '1px solid #ddd', backgroundColor: pensandoIA ? '#e8f5e9' : '#f0f2f5', outline: 'none', fontSize: '14px' }} 
                                />
                                <button onClick={() => generarConIA()} title="✨ Mejorar con IA" style={{ position: 'absolute', right: '5px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px' }}>✨</button>
                            </div>
                            <button onClick={enviarComentario} disabled={enviando} style={{ alignSelf: 'flex-end', padding: '5px 15px', borderRadius: '15px', border: 'none', backgroundColor: config?.color_principal || '#2E7D32', color: 'white', cursor: 'pointer', fontSize:'12px', fontWeight:'bold' }}>ENVIAR</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TarjetaMuro;